import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import * as actions from '../actions';
import HEADER_FUNCTIONS from '../utils/functions/headers';
import delay from 'xstream/extra/delay';
import sampleCombine from 'xstream/extra/sampleCombine';

const REQUEST_POLICYTYPES = 'requestPolicyTypes';

export function requestPolicyTypes(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(action => {
        return action.type === ActionTypes.FETCH_POLICY_TYPES;
    })
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url:
                GENERAL_FUNCTIONS.getBaseURL() +
                'api/policyType/claimApplication',
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_POLICYTYPES,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_POLICYTYPES)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchPolicyTypesSuccess(response)
                : actions.fetchPolicyTypesFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
